import React from 'react';

import { formatCurrency } from 'js/services/Format';

import Container from './Container';
import Text from './Text';
import Image from './Image';
import Date from './Date';
import Result from './Result';
import Amount from './Amount';

export default ({ transaction }) => (
  <Container>
    <Image logo_type={transaction.logo_type} logo={transaction.logo_src} />
    <Text>{transaction.human_description}</Text>
    <Amount>{formatCurrency(transaction.amount)}</Amount>
    <Result status={transaction.status}>{transaction.human_label}</Result>
    <Date>{transaction.created_at}</Date>
  </Container>
);
